import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainScreenComponent } from './main-screen/main-screen.component';
import { AuthGuard } from '../core/auth/auth.guard';
import { environment } from '../../environments/environment';

export const routingPaths = {
  empty: '',
  setting: 'setting-nav',
  cashFlow: 'cash-flow',
  dashboard: 'dashboard',
  clients: 'clients',
  serviceProvider: 'service-provider',
  account: 'account',
  activate: 'activation',
  passwordReset: 'password-reset',
  forgottenPassword: 'forgotten-password',
  welcome: 'welcome',
  administration: 'administration',
  accounting: 'accounting',
  users: 'users',
  roles: 'roles',
  details: 'details',
  expenses: 'expenses',
  sales: 'sales',
  invoices: 'invoices',
  view: 'view',
  new: 'new',
  notFound: 'not-found',
  notActivated: 'not-activated',
  config: 'config',
  reports: 'reports',
  rh: 'rh',
  employees: 'employees',
  imputations: 'imputations',
  candidates: 'candidates',
  projects: 'projects',
  logs: 'logs',
  pipeline: 'pipeline',
  prospects: 'prospects',
  absences: 'absences',
  addApplication: 'add-application'
};
const env = environment;
export const layoutRoutes: Routes = [
  {
    path: routingPaths.empty,
    component: MainScreenComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: routingPaths.notFound,
        loadChildren: () => import('./not-found/not-found.module').then((m) => m.NotFoundModule),
        data: {
          breadcrumb: 'NOT-FOUND',
        },
      },
      {
        path: routingPaths.notActivated,
        loadChildren: () => import('./not-activated/not-activated.module').then((m) => m.NotActivatedModule),
        data: {
          breadcrumb: 'NOT-ACTIVATED',
        },
      },
      {
        path: routingPaths.empty,
        redirectTo: env.landingPage,
        canActivateChild: [AuthGuard],
        pathMatch: 'full',
      },
      {
        path: routingPaths.account,
        canActivateChild: [AuthGuard],
        loadChildren: () => import('./../features/account/account.module').then((m) => m.AccountModule),
      },

      {
        path: routingPaths.dashboard,
        canActivateChild: [AuthGuard],
        loadChildren: () => import('./../features/dashboard/dashboard.module').then((m) => m.DashboardModule),
        data: {
          status: true,
        },
      },
      {
        path: routingPaths.rh,
        canActivateChild: [AuthGuard],
        data: {
          breadcrumb: 'RH_MENU_ITEM',
          title: 'RH_MENU_ITEM',
          status: true,
        },
        children: [
          {
            path: routingPaths.absences,
            canActivateChild: [AuthGuard],
            data: {
              breadcrumb: 'ABSENCES_LIST_MENU_ITEM',
              title: 'ABSENCES_LIST_MENU_ITEM',
              status: true,
            },
            loadChildren: () => import('../features/rh/leaves/leaves.module').then((m) => m.LeavesModule),
          },
          {
            path: routingPaths.employees,
            canActivateChild: [AuthGuard],
            data: {
              breadcrumb: 'EMPLOYEES_LIST_MENU_ITEM',
              title: 'EMPLOYEES_LIST_MENU_ITEM',
              status: true,
            },
            loadChildren: () => import('../features/rh/employees/employees.module').then((m) => m.EmployeesModule),
          },

          {
            path: routingPaths.imputations,
            canActivateChild: [AuthGuard],
            data: {
              breadcrumb: 'IMPUTATIONS_LIST_MENU_ITEM',
              title: 'IMPUTATIONS_LIST_MENU_ITEM',
              status: true,
            },
            loadChildren: () =>
              import('../features/rh/imputations/imputations.module').then((m) => m.ImputationsModule),
          },
          {
            path: routingPaths.candidates,
            canActivateChild: [AuthGuard],
            data: {
              breadcrumb: 'CANDIDATES_LIST_MENU_ITEM',
              title: 'CANDIDATES_LIST_MENU_ITEM',
              status: true,
            },
            loadChildren: () => import('../features/rh/candidates/candidates.module').then((m) => m.CandidatesModule),
          },
        ],
      },

      {
        path: routingPaths.accounting,
        canActivateChild: [AuthGuard],
        data: {
          breadcrumb: 'ACCOUNTING_MENU_ITEM',
          title: 'ACCOUNTING_MENU_ITEM',
          status: true,
        },
        children: [
          {
            path: routingPaths.expenses,
            data: {
              breadcrumb: 'EXPENSES_MENU_ITEM',
              title: 'EXPENSE_LIST_MENU_ITEM',
              status: true,
            },
            loadChildren: () =>
              import('./../features/accounting/expenses/expenses.module').then((m) => m.ExpensesModule),
          },
          {
            path: routingPaths.sales,
            data: {
              breadcrumb: 'SALES_MENU_ITEM',
              title: 'SALES_LIST_MENU_ITEM',
              status: true,
            },
            loadChildren: () => import('./../features/accounting/sales/sales.module').then((m) => m.SalesModule),
          },
          {
            path: routingPaths.invoices,
            data: {
              breadcrumb: 'INVOICES_MENU_ITEM',
              title: 'INVOICES_LIST_MENU_ITEM',
              status: true,
            },
            loadChildren: () => import('./../features/accounting/invoices/invoices.module').then((m) => m.InvoicesModule),
          },
          {
            path: routingPaths.cashFlow,
            data: {
              breadcrumb: 'CASH_FLOW_MENU_ITEM',
              title: 'CASH_FLOW_LIST_MENU_ITEM',
              status: true,
            },
            loadChildren: () =>
              import('./../features/accounting/cash-flow/cash-flow.module').then((m) => m.CashFlowModule),
          },
        ],
      },

      {
        path: routingPaths.administration,
        canActivateChild: [AuthGuard],
        data: {
          breadcrumb: 'ADMIN_MENU_ITEM',
          title: 'ADMIN_MENU_ITEM',
          status: true,
        },
        children: [
          {
            path: routingPaths.users,
            data: {
              breadcrumb: 'USERS_MENU_ITEM',
              title: 'USERS_LIST',
              status: true,
            },
            loadChildren: () => import('./../features/users/users.module').then((m) => m.UsersModule),
          },
          {
            path: routingPaths.setting,
            data: {
              breadcrumb: 'SETTING_MENU_ITEM',
              title: 'SETTING_LIST',
              status: true,
            },
            loadChildren: () =>
              import('./../features/administration/setting-navs/setting-navs.module').then((m) => m.SettingNavsModule),
          },
          {
            path: routingPaths.logs,
            data: {
              breadcrumb: 'LOG_LIST',
              title: 'LOG_LIST',
              status: true,
            },
            loadChildren: () => import('./../features/administration/logs/log.module').then((m) => m.LogModule),
          },
          {
            path: routingPaths.roles,
            canActivateChild: [AuthGuard],
            data: {
              breadcrumb: 'ROLES_MENU_ITEM',
              title: 'ROLES_LIST',
              status: true,
            },
            loadChildren: () => import('./../features/roles/roles.module').then((m) => m.RolesModule),
          },
          {
            path: routingPaths.clients,
            canActivateChild: [AuthGuard],
            data: {
              breadcrumb: 'CLIENT_MENU_ITEM',
              title: 'CLIENT_LIST',
              status: true,
            },
            loadChildren: () => import('./../features/administration/client/client.module').then((m) => m.ClientModule),
          },
          {
            path: routingPaths.serviceProvider,
            canActivateChild: [AuthGuard],
            data: {
              breadcrumb: 'SERVICE_PROVIDER_MENU_ITEM',
              title: 'SERVICE_PROVIDER_LIST',
              status: true,
            },
            loadChildren: () =>
              import('./../features/administration/service-provider/service-provider.module').then(
                (m) => m.ServiceProviderModule
              ),
          },
          {
            path: routingPaths.config,
            data: {
              breadcrumb: 'CONFIG_MENU_ITEM',
              title: 'CONFIG_LIST',
              status: true,
            },
            loadChildren: () =>
              import('./../features/administration/administration.module').then((m) => m.AdministrationModule),
          },
          {
            path: routingPaths.projects,
            data: {
              breadcrumb: 'PROJECTS_MENU_ITEM',
              title: 'PROJECTS_MENU_ITEM',
              status: true,
            },
            loadChildren: () => import('./../features/project/project.module').then((m) => m.ProjectModule),
          },
        ],
      },
      {
        path: routingPaths.pipeline,
        canActivateChild: [AuthGuard],
        data: {
          breadcrumb: 'PIPELINE_MENU_ITEM',
          title: 'PIPELINE_MENU_ITEM',
          status: true,
        },

        children: [
          {
            path: '',
            redirectTo: routingPaths.prospects,
            pathMatch: 'full',
          },
          {
            path: routingPaths.prospects,
            data: {
              breadcrumb: 'PROSPECTS_LIST_MENU_ITEM',
              title: 'PROSPECTS_LIST',
              status: true,
            },
            loadChildren: () =>
              import('./../features/pipeline/prospects/prospects.module').then((m) => m.ProspectsModule),
          },
        ],
      },
    ],
  },

  {
    path: routingPaths.passwordReset,
    loadChildren: () => import('./../authentication/reset/reset.module').then((m) => m.ResetModule),
    data: {
      breadcrumb: 'PASSWORD-RESET',
    },
  },
  {
    path: routingPaths.welcome,
    loadChildren: () => import('./../authentication/welcome/welcome.module').then((m) => m.WelcomeModule),
    data: {
      breadcrumb: 'PASSWORD-INIT',
    },
  },
  {
    path: routingPaths.forgottenPassword,
    loadChildren: () =>
      import('./../authentication/forgotten-password/forgotten-password.module').then((m) => m.ForgottenPasswordModule),
    data: {
      breadcrumb: 'FORGOTTEN-PASSWORD',
    },
  },
  {
  path: routingPaths.addApplication,
  loadChildren: () =>
  import('./../features/publicPage/condidates/create/create.module').then((m) => m.CreateModule),
  },

  {
    path: '**',
    redirectTo: routingPaths.notFound,
    data: {
      breadcrumb: 'NOT-FOUND',
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(layoutRoutes)],
  exports: [RouterModule],
})
export class LayoutRoutingModule {}
